export default __webpack_public_path__ + "static/media/chevronDownWhite.d3a5224e.svg";